// tslint:disable
export enum CaseCaseFollowUpScenario {
    /**
     * @description Nothing/error route
     */
    Undetermined = 0,
    /**
     * @description Create Workflow
     */
    CreateCase = 1,
}
(CaseCaseFollowUpScenario as any)['UNDETERMINED'] = 0;
(CaseCaseFollowUpScenario as any)['CREATECASE'] = 1;
